import { GenotypingDto, CreateGenotypingDto, UpdateGenotypingDto } from 'src/dto/genotyping.dto'
import { GenotypingService } from 'src/services/api/genotyping.service'

export class GenotypingController {
  private service: GenotypingService

  constructor() {
    this.service = new GenotypingService()
  }

  public async getGenotypingListByFarmId(farmId: string): Promise<GenotypingDto[]> {
    const response = await this.service.getGenotypingListByFarmId(farmId)
    return response.data
  }

  public async createGenotyping(data: CreateGenotypingDto): Promise<GenotypingDto> {
    const response = await this.service.createGenotyping(data)
    return response.data
  }

  public async updateGenotyping(data: UpdateGenotypingDto): Promise<GenotypingDto> {
    const response = await this.service.updateGenotyping(data)
    return response.data
  }

  public async deleteGenotyping(id: string): Promise<void> {
    const response = await this.service.deleteGenotyping(id)
    return response.data
  }
}
